const actions = {
    setHeaderBreadcrumbs(headerBreadcrumbs) {
        this._headerBreadcrumbs = headerBreadcrumbs;
    },

    clearHeaderBreadcrumbs() {
        this._headerBreadcrumbs = [];
    },
};

export default actions;
